module.exports = __webpack_public_path__ + "static/fonts/CoHeadlineCorp-Regular.d21070f.woff2";